import AspSignUpConfirmation from '../components/dtc/AspSignUpConfirmation';
import CcReferLeadConfirmation from '../components/dtc/CcReferLeadConfirmation';
import CcReferLeadConfirmationMedicaid from '../components/dtc/CcReferLeadConfirmationMedicaid';
import NpSignUpConfirmation from '../components/dtc/NpSignUpConfirmation';
import SignUpConfirmationMedicaid from '../components/dtc/SignUpConfirmationMedicaid';
import { LeadProgram } from '../constants';
import AspReferralConfirmation from './AspReferralConfirmation';
import NpReferralConfirmation from './NpReferralConfirmation';
import ReferralConfirmationMedicaid from './ReferralConfirmationMedicaid';

export default function LeadConfirmation({
  program,
  isDtc,
  isMedicaid,
  handleGoBack,
  leadInfo,
}: {
  isDtc: boolean;
  program: LeadProgram;
  isMedicaid: boolean;
  handleGoBack: () => void;
  leadInfo: {
    email: string;
    first_name: string;
    last_name: string;
    phone_number: string;
  };
}) {
  if (isDtc) {
    if (program === LeadProgram.ASP) {
      return isMedicaid ? (
        <SignUpConfirmationMedicaid
          handleGoBack={handleGoBack}
          program={program}
        />
      ) : (
        <AspSignUpConfirmation handleGoBack={handleGoBack} />
      );
    }

    if (program === LeadProgram.NP) {
      return isMedicaid ? (
        <SignUpConfirmationMedicaid
          handleGoBack={handleGoBack}
          program={program}
        />
      ) : (
        <NpSignUpConfirmation program={program} {...leadInfo} />
      );
    }
  }
  if (program === LeadProgram.CC && isMedicaid) {
    return (
      <div>
        <CcReferLeadConfirmationMedicaid
          handleGoBack={handleGoBack}
          program={program}
        />
      </div>
    );
  }

  if (program === LeadProgram.CC) {
    return (
      <div>
        <CcReferLeadConfirmation
          handleGoBack={handleGoBack}
          program={program}
        />
      </div>
    );
  }
  
  if (isMedicaid) {
    return (
      <ReferralConfirmationMedicaid
        handleGoBack={handleGoBack}
        program={program}
      />
    );
  }

  if (program === LeadProgram.ASP) {
    return <AspReferralConfirmation handleGoBack={handleGoBack} />;
  }

  if (program === LeadProgram.NP) {
    return <NpReferralConfirmation handleGoBack={handleGoBack} />;
  }

  return <>Refer Lead Confirmation Unsupported Program {program}</>;
}
